import React from 'react';
import {
    RichText,
    Image,
} from "@sitecore-jss/sitecore-jss-react";

interface LogoProps {
    logoField?: any,
    addressField?: any,
    mapUrl?: any,
    copyright?: any
}

const Logo: React.FC<LogoProps> = (props) => {
    const { logoField, addressField, mapUrl, copyright } = props;
    return (
        <>
            <div className="imc-footer-logo">
                <a
                    href="/"
                    className="imc-content--inline-block"
                    data-xpath="footer.logo"
                >
                    {logoField?.svgCode ? (
                        <div
                            dangerouslySetInnerHTML={{ __html: logoField.svgCode }}
                        />
                    ) : (
                        <Image className="imc-footer__logo" field={logoField} />
                    )}
                </a>
            </div>
            {addressField && mapUrl && (
                <div
                    className=""
                    data-xpath="footer.address"
                >
                    <a
                        href={mapUrl}
                        className="imc-link"
                        target="_blank"
                    >
                        <RichText field={addressField} />
                    </a>
                </div>
            )}
            {addressField && !mapUrl && (
                <div
                    className=""
                    data-xpath="footer.address"
                >
                    <RichText field={addressField} />
                </div>
            )}
            {(copyright) && <div className="">
                <p className="imc-content">
                    &copy; {new Date().getFullYear()} {copyright}
                </p>
            </div>}
        </>
    )
};

export default Logo;